import React from 'react';
import { sx, onGmMouseOver, onGmMouseOut } from './sx';
import styles from './growth-model.module.scss';
import { useGrowthModel } from './GrowthModelProvider';
import GrowthModelHeader from './components/GrowthModelHeader';
import PlanScreen from './components/PlanScreen';
import CohortScreen from './components/CohortScreen';
import MixScreen from './components/MixScreen';
import SourceScreen from './components/SourceScreen';
import BaseModelScreen from './components/BaseModelScreen';
import GroupRollupScreen from './components/GroupRollupScreen';
import AuthoringScreen from './components/AuthoringScreen';
import GovernanceScreen from './components/GovernanceScreen';
import ChangeLogScreen from './components/ChangeLogScreen';
import PublishModal from './components/PublishModal';
import CreateVersionModal from './components/CreateVersionModal';
import CutoffOverwriteModal from './components/CutoffOverwriteModal';
import AuthoringModal from './components/AuthoringModal';

export default function GrowthModelView() {
	const { vm } = useGrowthModel();
	return (
		<div className={styles.root} onMouseOver={onGmMouseOver} onMouseOut={onGmMouseOut}>
			<div
				style={sx(
					`height:100%;position:relative;display:flex;flex-direction:column;background:var(--bg-1);color:var(--ink-3);font-family:var(--font-sans);letter-spacing:-0.01em;--rh:${vm.rowH};--coh:${vm.cohRowH}`
				)}
			>
				<GrowthModelHeader vm={vm} />
				<main style={sx(`flex:1;min-height:0;display:flex`)}>
					<section style={sx(`flex:1;min-width:0;display:flex;flex-direction:column`)}>
						<PlanScreen vm={vm} />
						<CohortScreen vm={vm} />
						<MixScreen vm={vm} />
						<SourceScreen vm={vm} />
						<BaseModelScreen vm={vm} />
						<GroupRollupScreen vm={vm} />
						<AuthoringScreen vm={vm} />
						<GovernanceScreen vm={vm} />
						<ChangeLogScreen vm={vm} />
					</section>
				</main>
				<PublishModal vm={vm} />
				<CreateVersionModal vm={vm} />
				<CutoffOverwriteModal vm={vm} />
				<AuthoringModal vm={vm} />
			</div>
		</div>
	);
}
